import { Button } from "@components/controls/Button"
import { ChipList } from "@components/layout/ChipList"
import { IconCaretRight } from "@components/svg/Icons"
import { Link } from "eddev/routing"
import { ResourceCardFragment } from "../../types.graphql"

type Props = ResourceCardFragment

export function ResourceCard(props: Props) {
  return (
    <div className="grid-auto col-span-12 border-t py-4 text-left gap-y-3">
      <div className="col-span-12 md:col-span-5 type-title-s-medium stack-y-3">
        <div>
          <Link href={props.uri}>{props.title}</Link>
        </div>
        <ChipList chips={props.chips!} />
      </div>
      <div className="col-span-12 md:col-span-5 type-body-s-roman">{props.shortDescription}</div>
      <div className="col-span-12 md:col-span-2 type-body-s-roman justify-end hidden md:flex">
        <Button href={props.uri} variant="outline" rightIcon={<IconCaretRight />} size="default">
          Read More
        </Button>
      </div>
    </div>
  )
}
